.antFormItem {
  :global(.ant-form-item-label) {
    > :global(label.ant-form-item-required):not(:global(.ant-form-item-required-mark-optional)) {
      &::before {
        display: none;
      }

      &::after {
        display: inline-block;
        margin-right: 4px;
        color: var(--x-color-text-red);
        content: "*";
        font-family: SimSun, sans-serif;
        font-size: 14px;
        line-height: 1;
        visibility: visible;
      }
    }
  }
}

//:global(.ant-form-horizontal) {
//  .antFormItem {
//    :global(.ant-form-item-control) {
//      // Percent is important!
//      flex: 1 1 0%;
//    }
//  }
//}
